import { ACCEPT_COOKIES } from '../types/gdprTypes';

export const setAcceptCookies = (permissions) => ({
	type: ACCEPT_COOKIES,
	payload: permissions
});